import _ from 'lodash';

import { LocalStorage } from 'assets/js/auth/localstorage';

const DISABLE_LOGIN_ANIMATION_KEY = 'DISABLE_LOGIN_ANIMATION';
const THEME_ID_KEY_LOCAL_STORAGE = 'QRESERVE_THEME';
const THEME_ID_KEY_SESSION_STORAGE = 'THEME_ID';
const TRUE_STRING = 'true';

// storage points to the current browser window's storage session.
const storage = window.sessionStorage;

// storagePersistent points to the current browser window's persistent storage.
const storagePersistent = LocalStorage();

// DisableLoginAnimationFetch fetches the stored bool for whether or not to
// disable Login animation from local storage.
export const DisableLoginAnimationFetch = (original) => {
  let disabled = original;
  if (storagePersistent) {
    disabled = storagePersistent.getItem(DISABLE_LOGIN_ANIMATION_KEY) ===
      TRUE_STRING;
  }
  return disabled;
};

// DisableLoginAnimationPurge removes the value of the stored bool for whether
// or not to disable login animation.
export const DisableLoginAnimationPurge = () => {
  if (storagePersistent) {
    storagePersistent.removeItem(DISABLE_LOGIN_ANIMATION_KEY);
  }
};

// DisableLoginAnimationSet sets the value of the stored bool for whether or
// not to disable login animation.
export const DisableLoginAnimationSetTrue = () => {
  if (storagePersistent) {
    storagePersistent.setItem(DISABLE_LOGIN_ANIMATION_KEY, TRUE_STRING);
  }
};

// ThemeIdFetch fetches the theme ID from either session or local storage.
export const ThemeIdFetch = () => {
  let themeId = storage.getItem(THEME_ID_KEY_SESSION_STORAGE);
  if (!themeId && storagePersistent) {
    themeId = storagePersistent.getItem(THEME_ID_KEY_LOCAL_STORAGE);
  }

  return themeId;
};

// ThemeIdPurge removes the set theme ID from session and local storage.
export const ThemeIdPurge = () => {
  storage.removeItem(THEME_ID_KEY_SESSION_STORAGE);
  if (storagePersistent) {
    storagePersistent.removeItem(THEME_ID_KEY_LOCAL_STORAGE);
  }
};

// ThemeIdSet sets the theme ID in both session and local storage.
export const ThemeIdSet = (themeId) => {
  if (_.isNil(themeId)) throw Error('no theme ID given');
  storage.setItem(THEME_ID_KEY_SESSION_STORAGE, themeId);
  if (storagePersistent) {
    storagePersistent.setItem(THEME_ID_KEY_LOCAL_STORAGE, themeId);
  }
};
